module.exports = __webpack_public_path__ + "static/media/mail.9365a42b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mail.svg
// module id = 921
// module chunks = 0